import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from '../hooks/use-toast';
import { subscribeNewsletter } from '../services/api';

const NewsletterPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('hasSeenNewsletterPopup');
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem('hasSeenNewsletterPopup', 'true');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (firstName && lastName && email) {
      setLoading(true);
      try {
        await subscribeNewsletter({
          first_name: firstName,
          last_name: lastName,
          email: email
        });
        toast({
          title: "Discount Claimed!",
          description: "Check your email for your 10% off code.",
        });
        handleClose();
      } catch (error) {
        toast({
          title: "Error",
          description: "Failed to subscribe. Please try again.",
          variant: "destructive"
        });
      } finally {
        setLoading(false);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 animate-in fade-in">
      <div className="bg-white rounded-lg shadow-2xl max-w-4xl w-full overflow-hidden relative animate-in zoom-in-95">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 z-10 text-gray-500 hover:text-gray-700 transition-colors"
        >
          <X size={24} />
        </button>
        <div className="grid md:grid-cols-2">
          {/* Left side - Image */}
          <div className="hidden md:block relative">
            <img
              src="https://images.unsplash.com/photo-1603561596112-0a132b757442?w=600&q=80"
              alt="Jewelry"
              className="w-full h-full object-cover"
            />
          </div>
          {/* Right side - Form */}
          <div className="p-8 md:p-12 flex flex-col justify-center">
            <div className="mb-6 flex justify-center">
              <div className="w-12 h-12">
                <svg viewBox="0 0 100 100" className="w-full h-full">
                  <polygon points="50,10 90,30 90,70 50,90 10,70 10,30" fill="#1e3a5f" />
                  <polygon points="50,25 75,37.5 75,62.5 50,75 25,62.5 25,37.5" fill="white" />
                </svg>
              </div>
            </div>
            <h2 className="text-2xl font-light text-center mb-2 text-gray-800">
              Get 10% OFF your order
            </h2>
            <p className="text-center text-gray-600 mb-6 text-sm">
              Subscribe to our newsletter and unlock 10% off your order
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                type="text"
                placeholder="First name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                disabled={loading}
              />
              <Input
                type="text"
                placeholder="Last name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                disabled={loading}
              />
              <Input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
              <Button
                type="submit"
                className="w-full bg-[#5c2e2e] hover:bg-[#4a2424] text-white py-6"
                disabled={loading}
              >
                {loading ? 'Processing...' : 'Claim discount'}
              </Button>
              <Button
                type="button"
                variant="ghost"
                onClick={handleClose}
                className="w-full"
                disabled={loading}
              >
                No, thanks
              </Button>
            </form>
            <p className="text-xs text-gray-500 text-center mt-4">
              You are signing up to receive communication via email and can unsubscribe at any time.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterPopup;